import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import IconLabel from '../util/IconLabel';
import CapacitorRipple from '../capacitor/Ripple';
import Notifications from '../notifications/Notifications';

import styles from './Modal.css';
import { commonMessages } from '../messages/Common';
import { injectIntl, intlShape } from 'react-intl';
class Modal extends Component {
  static propTypes = {
    'onClose': PropTypes.func.isRequired,
    'shouldCloseOnOverlayClick': PropTypes.bool,
    'onRequestClose': PropTypes.func,
    'isOpen': PropTypes.bool.isRequired,
    'contentLabel': PropTypes.string.isRequired,
    'role': PropTypes.string,
    'data-test': PropTypes.string,
    'children': PropTypes.node,
    'hideCloseButton': PropTypes.bool,
    'intl': intlShape.isRequired,
    'fullScreen': PropTypes.bool,
  };

  /*
  Optional context passed down from the `ModalHarness` component which is used
  inside of vladbook.
  See: http://reactcommunity.org/react-modal/#custom-parent
   */
  static contextTypes = {
    parentSelector: PropTypes.func,
  };

  render() {
    const {
      onClose,
      hideCloseButton,
      onRequestClose,
      isOpen,
      contentLabel,
      shouldCloseOnOverlayClick,
      'data-test': dataTest,
      children,
      role,
      fullScreen,
    } = this.props;

    return (
      <ReactModal
        className={classnames(styles.modal, { 'is-capacitor': __CAPACITOR__ })}
        portalClassName={styles.portal}
        bodyOpenClassName={styles.bodyOpen}
        overlayClassName={fullScreen ? styles.overlayFullScreen : styles.overlay}
        onRequestClose={onRequestClose}
        parentSelector={this.context.parentSelector}
        isOpen={isOpen}
        onClose={onClose}
        contentLabel={contentLabel}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        hideCloseButton={hideCloseButton}
      >
        <Notifications />
        {!hideCloseButton && (
          <div className={styles.mobileHeaderBar}>
            <button
              onClick={onClose}
              className={classnames(styles.close, { [styles.closeFullScreen]: fullScreen })}
              data-test="modal.close"
              aria-label={this.props.intl.formatMessage(commonMessages.close)}
            >
              <CapacitorRipple version="center" />
              <IconLabel name="close" />
            </button>
          </div>
        )}

        <section
          className={fullScreen ? styles.modalContentWrapperFullScreen : styles.modalContentWrapper}
          data-test={dataTest}
          role={role}
        >
          <div
            className={fullScreen ? styles.modalContentInnerFullScreen : styles.modalContentInner}
          >
            {children}
          </div>
        </section>
      </ReactModal>
    );
  }
}

export default injectIntl(Modal);
